'use client';

import { c as _c } from "react/compiler-runtime";
import { Button, H6 } from '@material-bank/mb3-components';
import { MaterialCard, StepIntro } from '@material-bank/mtag-ui-components';
import { useTranslations } from '@material-bank/i18n';
import { ReactNode } from 'react';
import { useCreateAccount } from '../../../hooks/useCreateAccount';
import type { DialogOptionsProduct } from '../../../providers/AuthenticationDialogProvider';
type OptionsStepProps = {
  title: string;
  icon: ReactNode;
  product?: DialogOptionsProduct;
  description?: string;
  onSignIn: () => void;
};
export function OptionsStep(t0) {
  const $ = _c(22);
  const {
    title,
    icon,
    product,
    description,
    onSignIn
  } = t0;
  const t = useTranslations("authentication.dialog");
  const {
    isCreateAccountDisabled,
    createAccountClickHandler
  } = useCreateAccount();
  let t1;
  if ($[0] !== description || $[1] !== icon || $[2] !== product || $[3] !== title) {
    t1 = <div className="flex flex-col items-center gap-4 pt-3 px-6 w-full">{product ? <><H6 className="text-foreground font-medium">{title}</H6><MaterialCard productName={product.productName} variantSummary={product.variantSummary} imageUrl={product.imageUrl} /></> : <StepIntro title={title} icon={icon} description={description} />}</div>;
    $[0] = description;
    $[1] = icon;
    $[2] = product;
    $[3] = title;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== t) {
    t2 = t("signIn.label");
    $[5] = t;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== onSignIn || $[8] !== t2) {
    t3 = <Button variant="brand" size="xl" className="w-full rounded-full h-12" onClick={onSignIn} data-haptic="light" data-analyticsid="popup_modal_sign_in_sign_in_modal">{t2}</Button>;
    $[7] = onSignIn;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== t) {
    t4 = t("createAccount.label");
    $[10] = t;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== createAccountClickHandler || $[13] !== isCreateAccountDisabled || $[14] !== t4) {
    t5 = <Button variant="outline" size="xl" className="w-full rounded-full h-12" onClick={createAccountClickHandler} disabled={isCreateAccountDisabled} data-haptic="light">{t4}</Button>;
    $[12] = createAccountClickHandler;
    $[13] = isCreateAccountDisabled;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== t3 || $[17] !== t5) {
    t6 = <div className="flex flex-col gap-2 px-6 w-full">{t3}{t5}</div>;
    $[16] = t3;
    $[17] = t5;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== t1 || $[20] !== t6) {
    t7 = <div className="flex flex-col items-center gap-6 pb-6">{t1}{t6}</div>;
    $[19] = t1;
    $[20] = t6;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  return t7;
}